import { z } from 'zod'

import i18n from 'modules/core/lib/i18n'

// Basic approval form structure shared between approvals node and detailed
// approval forms. This is kept here to avoid circular dependencies.

const createNodeSidepanelSchema = () => {
  return z.object({
    nodeType: z.enum(['task', 'approvals', 'condition', 'trigger', 'conditionIf', 'conditionElse']),
    title: z.string().min(1, { message: i18n.t('workflows.task_form.validation.title_required') }),
    description: z
      .string()
      .min(1, { message: i18n.t('workflows.task_form.validation.description_required') }),
    nodeData: z.object({
      handlerType: z
        .string()
        .min(1, { message: i18n.t('workflows.task_form.validation.handler_type_required') }),
    }),
  })
}
// Export the schema instance for convenience (created lazily on first use)
export const nodeSidepanelSchema = createNodeSidepanelSchema()

// Type exports
export type NodeSidepanelSchema = z.infer<ReturnType<typeof createNodeSidepanelSchema>>
export type NodeSidepanelType = NodeSidepanelSchema['nodeType']
